"use strict";

exports.__esModule = true;
exports.tooltipAxisPointerFormatter = exports.realTimeXAxisFormatter = exports.defaultXAxisFormatter = void 0;
var _timeFormatters = require("../../../Utils/timeFormatters");
var _timeDefinitions = require("../../timeDefinitions");
var defaultXAxisFormatter = exports.defaultXAxisFormatter = function defaultXAxisFormatter(timezone) {
  return function (value) {
    return (0, _timeFormatters.formatToShortDayHour)(value, timezone);
  };
};
var realTimeXAxisFormatter = exports.realTimeXAxisFormatter = function realTimeXAxisFormatter(timezone) {
  return function (value) {
    return value % _timeDefinitions.MINUTE_IN_MILLIS === 0 ? (0, _timeFormatters.formatToTimeOnly)(value, timezone) : (0, _timeFormatters.formatToSecondsOnly)(value, timezone);
  };
};
var tooltipAxisPointerFormatter = exports.tooltipAxisPointerFormatter = function tooltipAxisPointerFormatter(timezone) {
  return function (params) {
    return (0, _timeFormatters.formatToDateTime)(params.value, timezone);
  };
};